import { mapGetters, mapMutations } from 'vuex';
import core from '../../store/quincy/core';
import { GETTERS, MUTATIONS } from '../../store/quincy/definitions';
const THREE = require('three');

export default {
  data() {
    return {
      intersection: {
        intersects: false,
        point: new THREE.Vector3(),
        normal: new THREE.Vector3()
      },
      doubleTap: false,
      active: false,
      click: null,
      cursorPosition: new THREE.Vector2(),
      interactionSubscription: null
    };
  },

  mounted() {
    core.raycaster = new THREE.Raycaster();
    this.interactionSubscription = this.$store.subscribe(mutation => {
      if (mutation.type === `quincy/${MUTATIONS.MODEL_LOADED}`) {
        this.initEvents();
      }
    });
  },

  beforeUnmount() {
    this.destroyEventListeners();
    this.interactionSubscription();
  },

  methods: {
    ...mapMutations('quincy', {
      $MODELLOADED: MUTATIONS.MODEL_LOADED,
      $TOGGLEDRAWING: MUTATIONS.TOGGLE_DRAWING,
      $MARKBODY: MUTATIONS.MARK_BODY,
      $UNMARKBODY: MUTATIONS.UNMARK_BODY,
      $CLICKSYMPTOM: MUTATIONS.CLICK_SYMPTOM,
      $SETACTIVESYMPTOM: MUTATIONS.SET_ACTIVE_SYMPTOM,
      $REMOVEACTIVESYMPTOM: MUTATIONS.REMOVE_ACTIVE_SYMPTOM
    }),
    initEvents() {
      core.container.addEventListener('mousedown', this.onMouseDown, {
        passive: false
      });
      core.container.addEventListener('mouseup', this.onMouseUp, {
        passive: false
      });
      core.container.addEventListener('mousemove', this.onMouseMove, {
        passive: false
      });
      core.container.addEventListener('touchstart', this.onTouchStart, {
        passive: false
      });
      core.container.addEventListener('touchend', this.onTouchEnd, {
        passive: false
      });
      core.container.addEventListener('touchmove', this.onTouch, {
        passive: false
      });
      core.container.addEventListener('touch', this.onTouch, {
        passive: false
      });
    },

    destroyEventListeners() {
      core.container.removeEventListener('mousedown', this.onMouseDown);
      core.container.removeEventListener('mouseup', this.onMouseUp);
      core.container.removeEventListener('mousemove', this.onMouseMove);
      core.container.removeEventListener('touchstart', this.onTouchStart);
      core.container.removeEventListener('touchend', this.onTouchEnd);
      core.container.removeEventListener('touchmove', this.onTouch);
      core.container.removeEventListener('touch', this.onTouch);
    },

    checkIntersection(onlyCheckIfOnBody = false) {
      if (!core.object) return;

      // this.triggerRender();

      const intersects = core.raycaster.intersectObject(core.object, true);
      const isOnBody = intersects => intersects.length > 0;

      if (isOnBody(intersects) && !onlyCheckIfOnBody) {
        const object = intersects[0];
        const point = object.point;
        const target = object.object.name;

        if (this.drawActive) {
          if (
            !target.match(/Symptom/) ||
            !this.symptomPoint ||
            object.object.userData.SymptomId !== this.symptomPoint.SymptomId // SymptomPoint is a SymptomReportSymptom...
          ) {
            this.$MARKBODY({ point, bodyPart: target });
          }
        }

        if (
          this.eraseActive &&
          target.match(/Symptom/) &&
          this.activeSymptom &&
          this.activeSymptom.SymptomId === object.object.userData.SymptomId
        ) {
          if (
            this.activeSymptom.isCurrent === true &&
            this.activeSymptom.SymptomPoints.length === 0
          ) {
            this.$emit('last-symptom-point-erased', this.activeSymptom);
            this.active = false;
            // return;
          }
          this.$UNMARKBODY({
            point,
            id: object.object.userData.Id,
            size: object.object.userData.Size,
            name: object.object.name
          });
        }

        if (!this.active) {
          this.$CLICKSYMPTOM({
            point,
            SymptomId: object.object.userData.SymptomId
          });
        }
      }

      if (this.drawActive === true && isOnBody(intersects) === false) {
        if (!this.activeSymptom) {
          // this.addLoadedSymptomsToBody();
        }
      }

      return isOnBody(intersects);
    },

    onMouseDown(event) {
      const IS_LEFTBUTTON = event.button === core.LEFT_MOUSEBUTTON;

      if (IS_LEFTBUTTON) {
        this.active = true;
      }

      if (this.checkDoubleClick()) {
        return;
      }

      if (IS_LEFTBUTTON && this.drawActive === true) {
        this.removeNonActiveMarkers();
      }

      this.click = Object.assign({}, this.cursorPosition);

      if (this.cameraActive === true) {
        this.setCursorPosition(event);
        return;
      }

      if (this.drawActive && IS_LEFTBUTTON) {
        this.emitDrawStatus(this.active);
      }
      event.preventDefault();
    },

    onMouseUp(event) {
      this.active = false;

      if (this.hasNotMovedCursor() && this.cameraActive) {
        this.checkIntersection();
        return;
      } else if (!this.hasNotMovedCursor() && this.cameraActive) {
        return;
      }
      this.checkIntersection();

      if (this.drawActive) {
        this.emitDrawStatus(this.active);
      }

      this.click = null;
      event.preventDefault();
    },

    onMouseMove(event) {
      this.setCursorPosition(event);

      if (this.active === false) {
        return;
      }
      if (this.hasNotMovedCursor()) {
        return;
      }
      if (this.cameraActive || event.button === core.RIGHT_MOUSEBUTTON) {
        return;
      }

      if (
        this.checkIntersection() ||
        this.cameraActive ||
        core.controls.enabled
      ) {
        event.preventDefault();
      }
    },

    onTouchStart(event) {
      this.setCursorPosition(event);
      this.click = Object.assign({}, this.cursorPosition);
      this.active = true;
      if (this.drawActive) {
        this.removeNonActiveMarkers();
        this.emitDrawStatus(this.active);
      }
      if (this.checkDoubleClick()) {
        return;
      }
    },

    onTouchEnd(event) {
      this.active = false;
      if (this.drawActive) {
        this.emitDrawStatus(this.active);
      }
      if (this.hasNotMovedFinger()) {
        this.checkIntersection();
        return;
      } else if (!this.hasNotMovedFinger()) {
        return;
      }
      this.checkIntersection();
      this.click = null;
      event.preventDefault();
    },

    onTouch(event) {
      this.setCursorPosition(event);

      if (this.hasNotMovedFinger()) {
        return;
      }

      if (
        (this.checkIntersection() &&
          this.cameraActive &&
          core.controls.enabled) ||
        this.drawActive ||
        this.eraseActive
      ) {
        event.preventDefault();
      }
    },

    setCursorPosition(event) {
      const position = this.getCursorPosition(event);

      const x =
        (position.x /
          (core.renderer.domElement.width / window.devicePixelRatio)) *
        2 -
        1;
      const y =
        -(
          position.y /
          (core.renderer.domElement.height / window.devicePixelRatio)
        ) *
        2 +
        1;

      this.cursorPosition.x = x;
      this.cursorPosition.y = y;
    },

    getCursorPosition(event) {
      const isTouchEvent = event => event.__proto__.hasOwnProperty('touches');

      if (isTouchEvent(event)) {
        event.clientX = event.touches[0].clientX;
        event.clientY = event.touches[0].clientY;
      }

      const margin = document.querySelector('canvas').offsetTop;
      const rect = core.container.getBoundingClientRect();
      const x = event.clientX - rect.left;
      const y = event.clientY - rect.top + -margin;
      return { x, y };
    },

    hasNotMovedCursor() {
      return (
        this.click !== null &&
        this.click.x === this.cursorPosition.x &&
        this.click.y === this.cursorPosition.y
      );
    },

    hasNotMovedFinger() {
      return (
        this.click !== null &&
        Math.abs(this.click.x - this.cursorPosition.x) < 0.015 &&
        Math.abs(this.click.y - this.cursorPosition.y) < 0.015
      );
    },

    emitDrawStatus(status) {
      this.$TOGGLEDRAWING(status);
      this.$emit('drawing', status);
    },
    checkDoubleClick() {
      // if (!this.doubleTap) {
      //   this.doubleTap = true;
      //   setTimeout(() => this.doubleTap = false, 500);
      // } else if (this.shouldResetCamera) {
      //   this.doubleTap = false;
      //   this.resetCamera();
      //   return true;
      // } else {
      //   this.doubleTap = false;
      // }
      return false;
    }
  },

  computed: {
    ...mapGetters('quincy', {
      $SETTINGS: GETTERS.SETTINGS
    }),
    shouldResetCamera() {
      return this.cameraActive === true && this.doubleTap;
    }
  }
};
